import { render, staticRenderFns } from "./AuthorizationErrorDialog.vue?vue&type=template&id=69cd21c0&scoped=true&"
import script from "./AuthorizationErrorDialog.vue?vue&type=script&lang=js&"
export * from "./AuthorizationErrorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd21c0",
  null
  
)

export default component.exports